(function () {
	var nextslide = function () {
		var images = jQuery(".flex-content.hero")
			.find(".hero_images.scroll")
			.find(".hero_image");
		if (images.length > 1) {
			var curr = images.filter(".current").length
				? images.filter(".current")
				: images.first();
			var next = curr.next().length ? curr.next() : images.first();
			curr.addClass("prev").removeClass("current");
			next.addClass("current").removeClass("prev");
			setTimeout(function () {
				curr.removeClass("prev");
			}, 2500);
		}
	};

	jQuery(document).ready(function () {
		var style = document.createElement('style');
		style.innerHTML = 'div.hero_images.scroll div.hero_image.current, div.hero_images.scroll div.hero_image.prev { transform: translate3d(100px, 0, 0) !important; }';
		document.head.appendChild(style);

 		setTimeout(function() {
			nextslide();
		}, 2500);
		var intervalId = window.setInterval(function () {
			nextslide();
		}, 5000);
	});
})(jQuery);
